import React from 'react';
import {  Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth'; // Replace with your authentication hook


const PrivateRoute = ({Component, requiredPrivilege}) => {
  const { isAuthenticated, roleAccess } = useAuth();
  // Check if user has required privilege for this route
  const hasPrivilege = roleAccess?.some(
    (priv) => priv.privilege === requiredPrivilege && priv.read === true
  );

  // Redirect if not authenticated or lacks privilege
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!hasPrivilege) return <Navigate to="/access-denied" replace />; // Custom "Access Denied" page

  return <Component />;

};

export default PrivateRoute;
